import { CrudServiceBase } from './CrudServiceBase';
import { FeeSheetTemplateDto } from '@/models/FeeSheetTemplates/FeeSheetTemplateDto';

export class FeeSheetTemplateService extends CrudServiceBase<FeeSheetTemplateDto> {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  async getAll() : Promise<FeeSheetTemplateDto[]> {
    return await this.client.get('/all');
  }
}